import(/* webpackMode: "eager", webpackExports: ["LandingPage"] */ "/vercel/path0/apps/web/components/landing-page.tsx");
